import React, { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import EnodBeaconClient from "../../clients/EnodBeaconClient";
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import useQuery from './useQuery';
import ResultViewVariantCount from './ResultViewVariantCount';


interface IProps {
    variant: any;
}


class VariantRow extends React.PureComponent<IProps> {
    render() {
        const { variant } = this.props;
        const { variantInternalId, variation } = variant || {};
        const { location, referenceBases, alternateBases } = variation || {};
        const { interval } = location || {};
        const { start } = interval;
        const { value } = start;
        const sequenceId = (location["sequence_id"] || "").startsWith("refseq:") ? location["sequence_id"].substr(7) : (location["sequence_id"] || "");
        const ref = referenceBases || variantInternalId.split(":").length > 2 ? variantInternalId.split(":")[2] : "";
        const alt = alternateBases || variantInternalId.split(":").length > 3 ? variantInternalId.split(":")[3] : "";

        return (
            <TableRow>
                <TableCell>{sequenceId}</TableCell>
                <TableCell>{value}</TableCell>
                <TableCell>{ref}</TableCell>
                <TableCell>{alt}</TableCell>
            </TableRow>
        );
    }
}


function ResultViewVariants() {
    const [numVariants, setNumVariants] = useState(null as number | null);
    const [variants, setVariants] = useState([] as any[]);
    const query = useQuery();

    useEffect(() => {
        const abortController = new AbortController();
        const options = {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json'
            },
            signal: abortController.signal
        } as RequestInit;
        (async () => {
            try {
                setNumVariants(null);
                setVariants([]);
                const [numVariants, variants] = await EnodBeaconClient.getVariants(query, abortController.signal);
                setNumVariants(numVariants);
                setVariants(variants);
            } catch (error) {
                if (!abortController.signal.aborted) {
                    // error!
                    console.log("ERROR: " + error);
                }
            }
        })();
        return () => {
            abortController.abort();
        };
    }, [query, setNumVariants, setVariants]);

    return (
        <div>
            {/* <ResultViewVariantCount variantCount={numVariants} /> */}
            <Table>
                <TableBody>
                    {
                       variants.map((v, idx) => (<VariantRow key={idx} variant={v} />))
                    }
                </TableBody>
            </Table>
        </div>
    );
}


export default ResultViewVariants;
